import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  getDealById,
  updateDeal,
  getUsers,
  getDealStages,
  getLeadTimeline,
  createLeadComment
} from "../api";

export default function DealDetail() {

const { id } = useParams();
const navigate = useNavigate();

const [deal, setDeal] = useState(null);
const [users, setUsers] = useState([]);
const [dealStages, setDealStages] = useState([]);
const [loading, setLoading] = useState(true);
const [saving, setSaving] = useState(false);
const [timeline, setTimeline] = useState([]);
const [newComment, setNewComment] = useState("");

useEffect(() => {

    load();

}, []);

async function load() {

    try {

        const dealRes = await getDealById(id);

const [
  usersRes,
  stagesRes,
  timelineRes
] = await Promise.all([
  getUsers(),
  getDealStages(),
  getLeadTimeline(dealRes.data.lead_id)
]);

setDeal(dealRes.data);
console.log("Deal Stage =>", dealRes.data.stage);
console.log("Deal Stages =>", stagesRes.data);
setUsers(usersRes.data);
setDealStages(stagesRes.data);

setTimeline(timelineRes.data);

    } catch (err) {

        console.log(err);

    } finally {

        setLoading(false);

    }

}

async function update(field, value) {

    setSaving(true);

    try {

        const updatedDeal = {
    ...deal,
    [field]: value,
};

await updateDeal(id, updatedDeal);

await load();

        setDeal(prev => ({

            ...prev,

            [field]: value,

        }));

    } catch (err) {

        console.log(err);

    } finally {

        setSaving(false);

    }

}
async function addTimelineComment() {
  if (!newComment.trim()) return;

  try {
    await createLeadComment(deal.lead_id, {
      comment: newComment,
    });

    setNewComment("");

    await load();
  } catch (err) {
    console.log("ADD TIMELINE COMMENT ERROR:", err);
  }
}

if (loading)

return (

<div style={{ padding:30 }}>

Loading...

</div>

);

if (!deal) return null;

const stageAlias = {
  "Approach Product Experience": "Site Visit",
  "Approach Meeting": "Office Meeting",
  "Closed": "Booked",
};

return (

<div style={{display:"flex",flexDirection:"column",height:"100%"}}>

<div
style={{
display:"flex",
justifyContent:"space-between",
alignItems:"center",
padding:"8px 24px",
borderBottom:"1px solid #eee",
background:"#fff",
minHeight:"110px"
}}
>

<div>

<button
onClick={()=>navigate(-1)}
style={{
border:"none",
background:"transparent",
cursor:"pointer",
fontSize:12,
color:"#555",
padding:0,
marginBottom:8
}}
>
← Back
</button>

<h1
style={{
margin:0,
fontSize:24,
fontWeight:700,
lineHeight:1.2
}}
>
{deal.deal_name}
</h1>

<div
style={{
marginTop:8
}}
>
<span
style={{
background:
deal.status === "Won"
? "#DCFCE7"
: deal.status === "Lost"
? "#FEE2E2"
: "#DBEAFE",

color:
deal.status === "Won"
? "#166534"
: deal.status === "Lost"
? "#991B1B"
: "#1E40AF",

padding:"6px 14px",
borderRadius:999,
fontWeight:600,
fontSize:12
}}
>
{deal.status}
</span>
</div>

<div
style={{
marginTop:6,
fontSize:15,
color:"#666"
}}
>
{deal.phone} • {deal.project_name} • ₹ {deal.deal_value} Cr
</div>

</div>

<div
style={{
display: "flex",
flexDirection: "column",
alignItems: "center",
width: "240px"
}}
>

  {saving && (
    <span
      style={{
        color: "#888",
        fontSize: 13,
        marginBottom: 10
      }}
    >
      Saving...
    </span>
  )}

  <div
    style={{
      display: "flex",
      gap: "10px",
      marginBottom: "15px"
    }}
  >

    <button
onClick={() => update("stage", "Deal Won")}
style={{
background:"#28a745",
color:"#fff",
border:"none",
padding:"8px 10px",
borderRadius:16,
cursor:"pointer"
}}
>
Deal Won
</button>

    <button
onClick={() => update("stage", "Deal Lost")}
style={{
background:"#dc3545",
color:"#fff",
border:"none",
padding:"8px 10px",
borderRadius:16,
cursor:"pointer"
}}
>
Deal Lost
</button>

  </div>

  <div
style={{
width: "100%",
display: "flex",
flexDirection: "column",
alignItems: "center"
}}
>

    <label
style={{
marginBottom: 8,
fontWeight: 600,
textAlign: "center"
}}
>
Assigned To
</label>

    <select
      value={deal.assigned_to || ""}
      onChange={(e) => update("assigned_to", Number(e.target.value))}
      style={{
        width: "100%",
        padding: "9px 12px",
        borderRadius: "12px",
        border: "1px solid #ddd",
        background: "#fff"
      }}
    >

      <option value="">
        Select User
      </option>

      {users.map((u) => (
        <option
          key={u.id}
          value={u.id}
        >
          {u.name}
        </option>
      ))}

    </select>

  </div>

</div>

</div>



<div
style={{
flex:1,
overflow:"auto",
padding:"16px 24px"
}}
>

<div
style={{
display: "grid",
gridTemplateColumns:"1.8fr 0.95fr",
gap: "20px",
alignItems: "start"
}}
>

{/* LEFT SIDE */}

<div>

<div
style={{
background:"#fff",
borderRadius:12,
padding:16,
boxShadow:"0 2px 8px rgba(0,0,0,.08)"
}}
>

<h3
style={{
margin:"0 0 16px",
fontSize:18,
fontWeight:600
}}
>
Pipeline Status
</h3>

<div
style={{
display:"grid",
gridTemplateColumns:"1fr 1fr",
columnGap:"16px",
rowGap:"10px"
}}
>
{(deal.stage === "Office Meeting" ||
  deal.stage === "Site Visit") && (
  <div
    style={{
      gridColumn: "1 / span 2",
      display: "grid",
      gridTemplateColumns:
        deal.stage === "Site Visit" ? "1fr 1fr" : "1fr",
      gap: 16,
      marginBottom: 8,
    }}
  >
    {/* Meeting Done Date */}
    <div>
      <label
        style={{
          display: "block",
          marginBottom: 4,
          fontWeight: 600,
          fontSize: 14,
        }}
      >
        Meeting Done Date
      </label>

      <input
        type="date"
        value={
          deal.meeting_date
            ? deal.meeting_date.split("T")[0]
            : ""
        }
        onChange={(e) =>
          update("meeting_date", e.target.value)
        }
        style={{
          width: "100%",
          height: 40,
          padding: "0 12px",
          borderRadius: 8,
          border: "1px solid #ddd",
        }}
      />
    </div>

    {/* Site Visit Date — only Site Visit stage par */}
    {deal.stage === "Site Visit" && (
      <div>
        <label
          style={{
            display: "block",
            marginBottom: 4,
            fontWeight: 600,
            fontSize: 14,
          }}
        >
          Site Visit Date
        </label>

        <input
          type="date"
          value={
            deal.site_visit_date
              ? deal.site_visit_date.split("T")[0]
              : ""
          }
          onChange={(e) =>
            update("site_visit_date", e.target.value)
          }
          style={{
            width: "100%",
            height: 40,
            padding: "0 12px",
            borderRadius: 8,
            border: "1px solid #ddd",
          }}
        />
      </div>
    )}
  </div>
)}
<div>

<label>Stage</label>

<select
  value={deal.stage}
onChange={(e)=>update("stage",e.target.value)}
style={{
width:"100%",
height:40,
padding:"0 12px",
borderRadius:8
}}
>

{dealStages.map((stage) => (
  <option
    key={stage.id}
    value={stage.stage_name}
  >
    {stage.display_name}
  </option>
))}

</select>

</div>

<div>

<label>Priority</label>

<select
value={deal.priority}
onChange={(e)=>update("priority",e.target.value)}
style={{
width:"100%",
height:40,
padding:"0 12px",
borderRadius:8
}}
>

<option>Hot</option>
<option>Warm</option>
<option>Cold</option>

</select>

</div>


</div>

</div>

<br/>

<div
style={{
background:"#fff",
borderRadius:12,
padding:16,
boxShadow:"0 2px 8px rgba(0,0,0,.08)"
}}
>

<h3>Deal Description</h3>

<textarea
rows={2}
placeholder="Write deal notes..."
value={deal.description || ""}
onChange={(e)=>update("description",e.target.value)}
style={{
width:"100%",
marginTop:10,
borderRadius:8,
padding:10,
resize:"vertical",
fontSize:14
}}
/>

</div>
{/* ================= ACTIVITY TIMELINE ================= */}

<div
  style={{
    background: "#fff",
    borderRadius: 12,
    padding: 18,
    boxShadow: "0 2px 8px rgba(0,0,0,.08)",
    marginTop: 20,
    minHeight: 250,
  }}
>
  <h3
    style={{
      margin: "0 0 15px",
      fontSize: 18,
      fontWeight: 600,
    }}
  >
    Activity Timeline
  </h3>

  <div
    style={{
      display: "flex",
      gap: 10,
      marginBottom: 20,
    }}
  >
    <input
      type="text"
      placeholder="Write a comment..."
      value={newComment}
      onChange={(e) => setNewComment(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          addTimelineComment();
        }
      }}
      style={{
        flex: 1,
        padding: 10,
        border: "1px solid #ddd",
        borderRadius: 8,
        outline: "none",
      }}
    />

    <button
      type="button"
      onClick={addTimelineComment}
      style={{
        background: "#16A34A",
        color: "#fff",
        border: "none",
        padding: "10px 18px",
        borderRadius: 8,
        cursor: "pointer",
      }}
    >
      Post
    </button>
  </div>

  {timeline.length === 0 ? (
    <div
      style={{
        color: "#888",
        fontSize: 14,
        padding: "15px 0",
      }}
    >
      No activity yet
    </div>
  ) : (
    <div>
      {timeline.map((item, index) => (
        <div
          key={`${item.event_type}-${item.id}-${index}`}
          style={{
            padding: "14px 0",
            borderBottom:
              index !== timeline.length - 1
                ? "1px solid #eee"
                : "none",
          }}
        >
          <div
            style={{
              fontSize: 15,
              fontWeight: 600,
              color: "#222",
              lineHeight: 1.5,
            }}
          >
            {item.description}
          </div>

          <div
            style={{
              marginTop: 6,
              fontSize: 12,
              color: "#888",
            }}
          >
            {item.user_name || "Unknown User"}
            {" · "}
            {new Date(item.created_at).toLocaleString("en-IN", {
              day: "2-digit",
              month: "short",
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })}
          </div>
        </div>
      ))}
    </div>
  )}
</div>
</div>

{/* RIGHT SIDE */}

<div>

<div
style={{
background:"#fff",
borderRadius:12,
padding:16,
boxShadow:"0 2px 8px rgba(0,0,0,.08)"
}}
>

<h3 style={{ marginBottom: 20 }}>
  Deal Details
</h3>

<div
  style={{
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    columnGap: 28,
    rowGap: 18,
  }}
>

  <div>
    <div style={{ color:"#888", fontSize:13 }}>Phone</div>
    <div style={{ fontWeight:600 }}>{deal.phone}</div>
  </div>

  <div>
    <div style={{ color:"#888", fontSize:13 }}>Email</div>
    <div style={{ fontWeight:600 }}>{deal.email || "-"}</div>
  </div>

  <div>
    <div style={{ color:"#888", fontSize:13 }}>Project</div>
    <div style={{ fontWeight:600 }}>{deal.project_name}</div>
  </div>

  <div>
    <div style={{ color:"#888", fontSize:13 }}>Deal Value</div>
    <div style={{ fontWeight:600 }}>
      ₹ {deal.deal_value} Cr
    </div>
  </div>

  <div>
    <div style={{ color:"#888", fontSize:13 }}>Stage</div>
    <div style={{ fontWeight:600 }}>{deal.stage}</div>
  </div>

  <div>
    <div style={{ color:"#888", fontSize:13 }}>Priority</div>
    <div style={{ fontWeight:600 }}>{deal.priority}</div>
  </div>

  <div>
    <div style={{ color:"#888", fontSize:13 }}>Assigned To</div>
    <div style={{ fontWeight:600 }}>
      {deal.assigned_name || "-"}
    </div>
  </div>

  <div>
    <div style={{ color:"#888", fontSize:13 }}>Status</div>
    <div style={{ fontWeight:600 }}>{deal.status}</div>
  </div>

</div>

</div>

</div>

</div>

</div>

</div>

);

}